$(function() {
		var Accordion = function(el, multiple) {
				this.el = el || {};
				this.multiple = multiple || false;

				var links = this.el.find('.article-title');
				links.on('click', {
						el: this.el,
						multiple: this.multiple
				}, this.dropdown)
		}

		Accordion.prototype.dropdown = function(e) {
				var $el = e.data.el;
				$this = $(this),
						$next = $this.next();

				$next.slideToggle();
				$this.parent().toggleClass('open');

				if (!e.data.multiple) {
						$el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
				};
		}
		var accordion = new Accordion($('.accordion-container'), false);
});

$(document).on('click', function (event) {
  if (!$(event.target).closest('#accordion').length) {
    $(this).parent().toggleClass('open');
  }
});


$(document).ready(function() {
    /*setTimeout( function() {
      if($('body').hasClass('template--index') && $('.recommendation-modal__container').length <= 0) {
        var pop_cookie = $.cookie('pop_cookie');
        if(pop_cookie === undefined && pop_cookie != true)
        Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
      }
    }, 10000);*/
  
    $("body").on('click', "#5off", function() {
      Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
	});
  
    $("body").on('click', ".flt-bttn-close", function() {
      $(this).hide();
      $("#5off").hide();
	});
  
    $("body").on('click', ".popuppriv", function() {
      $.cookie('pop_cookie', 'true', { expires: 1 });
      $('.carousel__button.is-close').trigger('click');
	});
  
    $("body").on('click', ".carousel__button.is-close", function() {
      $.cookie('pop_cookie', 'true', { expires: 1 });
	});
  
    $(".signupbtn").click(function() {
      $('html, body').animate({
          scrollTop: $("footer.footer--root").offset().top
      }, 2000);
	});

  $(".sstriobtn a").click(function() {
      $('html, body').animate({
          scrollTop: $(".lpfrmsec").offset().top
      }, 2000);
	});


$('.srchbar').on('submit', function(e) {
    e.preventDefault();
    var search  = $(this).find('input[name="search"]').val().toLowerCase();
    $('.faqsec .container h3').remove();
    //console.log(search);
    if(search != '') {
	    $('.accordion-container .content-entry').hide();
	    $('h4.faqhed').hide();
	    $('.faqsec .col-6').hide();
      	var flag = 0;
	    $('.accordion-container .content-entry').each(function() {
	    	var title = $(this).find('h4.article-title').text().toLowerCase();
	    	var content = $(this).find('.accordion-content').text().toLowerCase();
	    	//console.log(title + ' - ' + content);
	    	if(title.indexOf(search) != -1 || content.indexOf(search) != -1) {
			    $(this).show();
			    $(this).closest('.faqbx').find('h4.faqhed').show();
			    $(this).closest('.faqsec .col-6').show();
              	flag++;
			}
	    })
        console.log(flag);
        if(flag == 0) {
          $('.faqsec .container').prepend('<h3>Sorry that query did not result to anything. <a style="text-decoration: underline;color: #fa198d;" href="/pages/contact-us">Contact us</a> for your inquiry instead.</h3>');
        }
	} else {
		$('.accordion-container .content-entry').show();
	    $('h4.faqhed').show();
	    $('.faqsec .col-6').show();
	}
	$('html, body').animate({
        scrollTop: $(".srchbar").offset().top
    }, 2000);
})


$("body").on("click",".expand",function(){
  $(this).closest(".exp_content").find(".extra_box").slideToggle(300);
  if ($(this).text() == "Read More"){
       $(this).text("Read Less");
  }
  else{
       $(this).text("Read More");
  }
});
  
  
  

});



jQuery(document).ready(function($){

    jQuery(".blog-fil").click(function(){
      jQuery(".blog--header").toggle();
    });

    jQuery("#teamcarousel").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      dots: false,
      loop: true,
      margin: 0,
      responsiveClass: true,
      autoHeight: false,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/left-arrow.png">','<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/right-arrow.png">'],
      items: 4,
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 2
        },

        1024: {
          items: 4
        },

        1366: {
          items: 4
        }
      }
    });    

    jQuery("#presscarousel").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      dots: false,
      loop: true,
      margin: 40,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/back1.png">','<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/next1.png">'],
      items: 3,
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 2
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    });    

    jQuery(".article_slider").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      dots: false,
      loop: true,
      margin: 40,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/back1.png">','<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/next1.png">'],
      items: 3,
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 2
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    }); 
  
    jQuery("#feapresscarousel").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      dots: false,
      loop: true,
      margin: 40,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/back.png">','<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/next.png">'],
      items: 3,
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 2
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    });    
    
    jQuery("#newstoriescarousel").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      dots: false,
      loop: true,
      margin: 40,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/back1.png">','<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/next1.png">'],
      items: 3,
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 2
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    });

    jQuery("#allrecepiecarousel").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      dots: false,
      loop: true,
      margin: 40,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/back1.png">','<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/next1.png">'],
      items: 3,
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 2
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    });    
    
    jQuery("#tagstoriescarousel").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      dots: false,
      loop: true,
      margin: 40,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/back1.png">','<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/next1.png">'],
      items: 3,
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 2
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    });    
    
    jQuery("#tagstoriescarousel1").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      dots: false,
      loop: true,
      margin: 40,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/back.png">','<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/next.png">'],
      items: 3,
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 2
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    });

    jQuery("#tagstoriescarousel2").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      dots: false,
      loop: true,
      margin: 40,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/back.png">','<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/next.png">'],
      items: 3,
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 2
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    });

    jQuery("#homebannercarousel").owlCarousel({
      autoplay: true,
      lazyLoad: true,
      dots: true,
      loop: true,
      margin: 40,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: false,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/back.png">','<img src="https://cdn.shopify.com/s/files/1/0597/1122/6025/files/next.png">'],
      items: 1,
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 1
        },

        1024: {
          items: 1
        },

        1366: {
          items: 1
        }
      }
    });

    jQuery(".pod-btn").click(function() {
        jQuery('html,body').animate({
            scrollTop: jQuery(".pod-iframe").offset().top},
            'slow');
    });


    // Swiper: Slider
    new Swiper('.ltswipecont', {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 3500,
        autoplay: {
          delay: 0,
        },
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
    });
        
   
    var swiper = new Swiper(".sponswipecont_sl", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        speed: 5000,
        autoplay: {
          delay: 1,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
        breakpoints: {
          640: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 5,
          }
        }
    });     
  
    new Swiper('.sponswipecont_1', {
        loop: true,
        spaceBetween: 60,
        slidesPerView: '1',
        autoplay: {
            delay: 5000,
        },
        allowTouchMove: false,
        navigation: {
            nextEl: '.swiper-button-next.swtesti',
            prevEl: '.swiper-button-prev.swtesti',
        }
    });
  
   
    var review_slider = new Swiper('.testiswipecont', {
        spaceBetween: 25,
        centeredSlides: false,  
        loop: true,
        /*loopedSlides: 4,*/
        slidesPerView: 1,
        allowTouchMove: true,
        freeMore: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0:{
             slidesPerView: 1,
             freeMore: false,
             autoplay: {
              enabled: true,
              delay: 5000
            },
             speed: 500,
          },
          640: {          
            slidesPerView: 'auto',
            speed: 6000,
            autoplay: {
              enabled: true,
              delay: 0
            },
          }
        }
    });
   $(".testimonials-wrapper").hover(function(){
      const get_translate = review_slider.getTranslate();
      review_slider.setTranslate(get_translate);
      review_slider.autoplay.stop();
   },function() {
     review_slider.slideTo(review_slider.activeIndex, 3000,false);
     review_slider.autoplay.start();
   }); 
 /*
    $(".testiswipecont").hover(function(){
  
      let get_translate = review_slider.getTranslate();
      console.log(get_translate);
      review_slider.destroy();
      review_slider = new Swiper('.testiswipecont', {
        spaceBetween: 25,
        centeredSlides: false,  
        loop: true,
     
        slidesPerView: 1,
        allowTouchMove: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0:{
             slidesPerView: 1,
             autoplay: {
              enabled: true,
              delay: 5000,
              disableOnInteraction: false
            },
             speed: 500,
          },
          640: {          
            slidesPerView: 'auto',
            speed: 500,
            autoplay: {
              enabled: false,
              delay: 0,
              disableOnInteraction: false
            },
          }
        }
      });
      review_slider.controller.setTranslate(get_translate);
    },
    function() {
      let get_translate = review_slider.getTranslate();
      review_slider.destroy();
      review_slider = new Swiper('.testiswipecont', {
        spaceBetween: 25,
        centeredSlides: false,  
        loop: true,
     // loopedSlides: 4,
        slidesPerView: 1,
        allowTouchMove: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0:{
             slidesPerView: 1,
             autoplay: {
              enabled: true,
              delay: 5000,
              disableOnInteraction: false
            },
             speed: 500,
          },
          640: {          
            slidesPerView: 'auto',
            speed: 8000,
            autoplay: {
              enabled: true,
              delay: 0,
              disableOnInteraction: false
            },
          }
        }
      });
     review_slider.controller.setTranslate(get_translate);
    });
    */

    var swiper = new Swiper(".proswipecont", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        speed: 2000,
        // autoplay: {
        //   delay: 0,
        // },
        navigation: {
            nextEl: '.swiper-button-next.proswiper',
            prevEl: '.swiper-button-prev.proswiper',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          }
        }
    });

    $('.read_more a').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.ihsubtbcont').find('.read-more').toggleClass('active');
        $(this).text(function(i, text){
            return text === "READ MORE" ? "READ LESS" : "READ MORE";
        })
    })



     new Swiper('.banner_product', {
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });




  const cartJson = '/cart.json';
  async function getCartJson() {
    fetch(cartJson)
      .then((res) => {
        return res.json();
      })

      .then((data) => {

        // Get Product Info from Shopify
        let productInfo = data.item_count;
        $(".header--cart-button span.cart--external--total-items").text(productInfo);
      })
  }

  
  (function(ns, fetch) {
    if (typeof fetch !== 'function') return;
  
    ns.fetch = function() {
      const response = fetch.apply(this, arguments);
  
      response.then(res => {
        if ([
            `${window.location.origin}/cart.js`,
            `${window.location.origin}/cart/add.js`,
            `${window.location.origin}/cart/update.js`,
            `${window.location.origin}/cart/change.js`,
            `${window.location.origin}/cart/clear.js`,
          ].includes(res.url)) {
          res.clone().json().then( (data) => {
            getCartJson()
          });
        }
      });
  
      return response;
    }
  
  }(window, window.fetch))
  
});


jQuery(function($){
     function getUrlParameter(param) {
        let pageUrl = window.location.search.substring(1);
        let urlVariables = pageUrl.split('&');

        for (let i = 0; i < urlVariables.length; i++) {
            let paramName = urlVariables[i].split('=');

            if (paramName[0] === param) {
                return paramName[1];
            }
        }
        return null; // Parameter not found
    }
    let paramValue = getUrlParameter('is_program');
    if (paramValue === 'true' || paramValue === true) {
       let is_open = 0;
       var openDialog = setInterval(function(){
         if($("#nav-toggle-widget").length>0){
           $("#nav-toggle-widget").trigger("click");
           clearInterval(openDialog);
         }
       });
    } 
});


